// extracted by mini-css-extract-plugin
export default {"timeSlotContainer":"TimeSlotContainer-module__timeSlotContainer___3c67D","discountWrapper":"TimeSlotContainer-module__discountWrapper___141m2"};